<script
    setup
    lang="ts"
    generic="T extends {
    id: string
    filename?: string|null|undefined,
    size?: string|number|null|undefined,
    contentType?: string|null|undefined,
}"
>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import DownloadableFileListItem from './DownloadableFileListItem.vue';

const props = withDefaults(
    defineProps<{
        files: T[] | null | undefined;
        downloadingFiles?: Iterable<string>;
    }>(),
    {
        downloadingFiles: () => [],
    }
);

const { t } = useI18n();

const emit = defineEmits<{
    (e: 'download', file: T, event: MouseEvent): void;
}>();

const downloadingFileIds = computed(() => new Set(props.downloadingFiles));

const normalizedFiles = computed<T[]>(() => props.files ?? []);

const isEmpty = computed(() => normalizedFiles.value.length <= 0);

function downloadHandler(file: T, event: MouseEvent) {
    emit('download', file, event);
}
</script>

<template>
    <div class="downloadable-file-list">
        <template v-if="isEmpty">
            <div class="text-200 text-center">{{ t('noFiles') }}</div>
        </template>
        <template v-else>
            <template v-for="file of normalizedFiles" :key="file.id">
                <slot
                    name="item"
                    :file="file"
                    :loading="downloadingFileIds.has(file.id)"
                >
                    <DownloadableFileListItem
                        :filename="file.filename"
                        :file-size="file.size"
                        downloadable
                        :loading="downloadingFileIds.has(file.id)"
                        @download="downloadHandler(file, $event)"
                    />
                </slot>
            </template>
        </template>
    </div>
</template>
<i18n>
{
    "en": {
        "noFiles": "-- no files --"
    },
    "nl": {
        "noFiles": "-- geen bestanden --"
    },
    "fr": {
        "noFiles": "-- aucun fichier --"
    }
}
</i18n>
